import { jsx, jsxs } from "react/jsx-runtime";
import { Spin } from "antd";
import { useOutletContext } from "@umijs/max";
import useStyles from "../../style";
import { getLogo } from "../../../../utils/logo";
const LoginWrapper = ({ backgroundImage, loading, children }) => {
  const { styles, cx } = useStyles({ backgroundImage });
  const { logo } = useOutletContext();
  return /* @__PURE__ */ jsxs("div", { className: styles.loginWrapper, children: [
    /* @__PURE__ */ jsx("div", { className: styles.left, children: /* @__PURE__ */ jsx(
      "img",
      {
        className: cx([styles.logo, "ti-login-logo"]),
        src: logo || getLogo("white"),
        alt: "LOGO"
      }
    ) }),
    /* @__PURE__ */ jsx("div", { className: styles.right, children: /* @__PURE__ */ jsx(Spin, { wrapperClassName: styles.rightSpin, spinning: loading, children }) })
  ] });
};
var LoginWrapper_default = LoginWrapper;
export {
  LoginWrapper_default as default
};
